export default __webpack_public_path__ + "static/media/Arrow-Blue-down.439e6da2.svg";